import { render, staticRenderFns } from "./ProcessCreateComprehensiveAccident.vue?vue&type=template&id=47befed4"
import script from "./ProcessCreateComprehensiveAccident.vue?vue&type=script&lang=js"
export * from "./ProcessCreateComprehensiveAccident.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports